module.exports = __webpack_public_path__ + "img/singapore-flag.5552c498.svg";